import React from 'react';
import { Glyphicon, Button } from 'react-bootstrap';
import actions from '../../../../../constants/actions';
import { SortableElement } from 'react-sortable-hoc';

const SortableItem = SortableElement((props) => {

  const onPressAction = (id, label, hidden, action) => e => {
    props.showModalHandle(id, label, hidden, action);
  }

  const {
    value,
  } = props;

  return (
    <tr className="sortable-tr">
      <td className="sortable-td">{value.label}</td>
      <td className="sortable-td">
        <Button
          style={{ border: 'none' }}
          onClick={onPressAction(value.id, value.label, value.hidden, actions.edit)}
        >
          <Glyphicon glyph="pencil" />
        </Button>
        <Button
          style={{ border: 'none' }}
          onClick={onPressAction(value.id, value.label, value.hidden, actions.hide)}
        >
          <Glyphicon
            glyph={(value.hidden === 0 ? "eye-open" : "eye-close")}
          />
        </Button>
        <Button
          style={{ border: 'none' }}
          onClick={onPressAction(value.id, value.label, value.hidden, actions.delete)}
        >
          <Glyphicon glyph="trash" />
        </Button>
        <Button
          style={{ border: 'none' }}
          onClick={onPressAction(value.id, value.label, value.hidden, actions.detail)}
        >
          <Glyphicon glyph="th-list" />
        </Button>
      </td>
    </tr>
  )
})

export default SortableItem;


// WEBPACK FOOTER //
// ./src/app/screens/sections/sectionsList/sectionsSortable/sortableItem.js